import { h, Fragment } from "preact";
import { useState } from "preact/hooks";
import { Typography } from "antd";
import TestKeys from "./TestKeys";
import ProdKeys from "./ProdKeys";
import './APITab.css'
import ApiBaseUrl from "./components/ApiBaseUrl.jsx";

const ProdModePage = ({ setCurrentPage }) => {
  return (
    <div className="api-page">
      <div className="keys-section">
        <Typography.Title level={3}>My API keys</Typography.Title>
        <div>
          <TestKeys />
        </div>
        <div>
          <ProdKeys />
        </div>
      </div>
      <div className="info-section">
        <ApiBaseUrl />
        <div className="info-box">
        <Typography.Title level={3}>Welcome to the Production</Typography.Title>
        <Typography.Text>
          Congratulations! You have generated your Production keys! Please use
          the{" "}
          <a target="_blank" href="/documentation">
            Documentation
          </a>{" "}
          to implement Verigram modules correctly.
          <br /> <br />
          If you need to change active API (for security purposes) please press
          Generate NEW Access keys. Then replace old access keys with the new
          ones on your website. After that you can revoke old access keys to
          prevent unsanctioned access to your data.
          <br /> <br />
          Please note, that you can have only two pair of keys at once.
          <br /> <br />
          If you are not ready for the production mode yet, you can go back to
          the Test Mode.
        </Typography.Text>
        </div>
      </div>
    </div>
  );
};

export default ProdModePage;
